export const getFutureValueFactor = (
	monthlyRate: number,
	months: number,
): number =>
	monthlyRate <= 0 ? months : ((1 + monthlyRate) ** months - 1) / monthlyRate;
